import React from 'react'
import OverlayHome from './components/OverlayHome'
import FeaturedCollections from './components/FeaturedCollections'
import TrendingNow from './components/TrendingNow'
import AudioSeries from './components/AudioSeries'
import EbooksHome from './components/EbooksHome'
import Top10AudioSeries from './components/TopTenAudioSeries'
import Footer from '../common/UI/Footer'
import NewsLetter from '../common/UI/NewsLetter'
import TrendingVideos from './components/VideosHome'
import SeriesTopTen from './components/SeriesTopTen'
import AudiobookGrid from './components/BooksGrid'
import ShortsCarousel from './components/ShortsCarousel'
import style from './components/Css/Homestyles.module.css'
import AudioBookCarousel from './components/AudioBookCarousel'
import ImageSliderr from './components/SliderHomepage'


function Homepage() {
  return (
    <>
    <div className={style.homeBackground}>
    <OverlayHome type={"Home"} category={"audio"}/>
    <FeaturedCollections/>
    <TrendingNow/>
    <AudioSeries/>
    <ImageSliderr/>
    <ShortsCarousel/>
    <EbooksHome/>
    <Top10AudioSeries/>
    <AudioBookCarousel/>
    <TrendingVideos/>
    <SeriesTopTen/>
    <NewsLetter/>
    <Footer/>
    </div>

    </>
  )
}

export default Homepage